<template>
  <div v-rect-loading="loading" class="notification-template-list">
    <TableList
      class="job-template-list"
      :listData="tableData"
      :table-columns="tableColumns"
      :actionBtn="actionBtn"
      @create="addLayout"
    >
      <template #filter>
        <el-input
          v-model="searchTemplateName"
          clearable
          class="el-input keywords-filter"
          :placeholder="$t(`${i18nPrefix}.label.layoutName`)"
          @input="handleKeywordsChange"
        ></el-input>
      </template>
    </TableList>
    <DialogWrapper
      :show.sync="deleteDialog.show"
      :loading="deleteDialog.loading"
      :title="deleteDialog.title"
      @save="handleDelete"
    ></DialogWrapper>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import { addI18nProperty } from '@/i18n'
import TableList from '@/components/tableList/allowDragSortTable.vue'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    TableList,
    DialogWrapper
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.notification',
      searchTemplateName: null,
      tableData: [],
      deleteDialog: {
        show: false,
        loading: false,
        id: null,
        title: null
      }
    }
  },
  computed: {
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.layoutName`),
          dataKey: 'name'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.companyName`),
          dataKey: 'companyI18nName'
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          show: (rowData) => !rowData.disabled,
          onclick: this.handleEdit
        },
        delete: {
          show: (rowData) => !rowData.disabled,
          onclick: this.showDeleteDialog,
          labelI18nKey: 'common.btn.delete'
        },
        view: {
          show: true,
          onclick: this.handleView,
          labelI18nKey: 'common.btn.view'
        }
      }
    }
  },
  created () {
    this.initData()
  },
  methods: {
    ...mapActions('notificationTemplate', ['searchLayoutTemplate', 'deleteLayoutTemplate']),
    handleEdit (row) {
      this.$router.push({
        path: `/v-admin/notification-management/layout-template/edit/${row.id}`,
        query: this.$route.query
      })
    },
    handleView (row) {
      this.$router.push({
        path: `/v-admin/notification-management/layout-template/view/${row.id}/`,
        query: this.$route.query
      })
    },
    async initData () {
      this.loading = true
      try {
        await this.searchTemplateList()
      } finally {
        this.loading = false
      }
    },
    async searchTemplateList () {
      this.parseQuery()
      const params = {
        search_template_name: this.searchTemplateName
      }
      if (!this.loading) {
        this.$eventBus.$emit('showLoading', true)
      }
      try {
        const resp = await this.searchLayoutTemplate(params)
        if (resp) {
          _.forEach(resp, item => {
            addI18nProperty(item, 'companyI18nName', 'company_cn_name', 'company_en_name')
          })
          this.tableData = resp
        }
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    },
    async addLayout () {
      this.$router.push('/v-admin/notification-management/layout-template/add')
    },
    showDeleteDialog (rowData) {
      this.deleteDialog.show = true
      this.deleteDialog.id = rowData.id
      this.deleteDialog.title = this.$t(`${this.i18nPrefix}.message.deleteLayout`, { name: rowData.name, company: rowData.companyI18nName })
    },
    async handleDelete () {
      this.deleteDialog.loading = true
      try {
        const resp = await this.deleteLayoutTemplate(this.deleteDialog.id)
        if (resp) {
          this.deleteDialog.show = false
          this.searchTemplateList()
        }
      } finally {
        this.deleteDialog.loading = false
      }
    },
    handleKeywordsChange () {
      if (!this.keywordsSearchDebounce) {
        this.keywordsSearchDebounce = _.debounce(this.formatSearchData, 1000)
      }
      this.keywordsSearchDebounce()
    },
    formatSearchData () {
      this.$router.push({
        query: {
          ...this.$route.query,
          name: this.searchTemplateName
        }
      })
    },
    parseQuery () {
      this.searchTemplateName = this.$route.query.name
    }
  },
  watch: {
    $route: {
      handler () {
        this.searchTemplateList()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.notification-template-list {
  .title {
    font-size: 16px;
    margin-bottom: 20px;
  }
}
</style>
